import DealButton from './DealButton';

export default DealButton;
